import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import styled from "styled-components";
import "./App.css";
import ResumePage from "./resume";
import PortfolioPage from "./portfolio";
import SetMeetingPage from "./setMeeting";
import ContactPage from "./contactForm";
import AboutMe from "./aboutMe";
import StartupPage from "./startup";
import Skills from "./Skills";
import ForgeLockPage from "./forgelock";

const HomePage = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        margin: "1.7rem 0rem 0rem 0rem",
      }}
    >
      <AboutMeContainer>
        <AboutMe />
      </AboutMeContainer>
      <div style={{ margin: "8rem 0rem 4rem 0rem" }} />

      <PortfolioPage />
      <div style={{ margin: "4rem 0rem 2rem 0rem" }} />

      {/* <StartupPage />
      <div style={{ margin: "8rem 0rem 8rem 0rem" }} /> */}

      <ContactPage />
      {/* <div style={{ margin: "8rem 0rem 8rem 0rem" }} /> */}
      <div style={{ margin: "4rem 0rem 4rem 0rem" }} />
    </div>
  );
};

const AboutMeContainer = styled.div`
  margin: 10rem 0rem 0rem 0rem;
  height: 70vh;
  @media (max-width: 768px) {
    margin: 1rem 0rem 2rem 0rem;
  }
  @media (max-width: 1280px) {
    margin: 2rem 0rem 3rem 0rem;
  }
`;

export default HomePage;
